import {Injectable} from '@angular/core';

@Injectable()

export class PanelService {

  constructor() {
  }
}
